/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const FilterHideSquareBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6 3c-.874 0-1.661.374-2.21.97l-.057.065 16.232 16.232.064-.058A3.004 3.004 0 0 0 21 18V6a3 3 0 0 0-3-3H6Zm8.543 9.75h.957a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-2.457l1.5 1.5Zm-3-3H17.5a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-7.457l1.5 1.5ZM3 6c0-.217.023-.428.067-.632l3.055 3.055A.498.498 0 0 0 6 8.75v.5a.5.5 0 0 0 .5.5h.949l1.5 1.5H8.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1.949l1.5 1.5H11a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2c.125 0 .24-.046.327-.122l5.305 5.305A3.01 3.01 0 0 1 18 21H6a3 3 0 0 1-3-3V6Z" /></svg>);
const FilterHideSquare = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={FilterHideSquareBase} {...rest} ref={ref} />);
export default FilterHideSquare;